import { Component, inject, Input, signal } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IImageEntity } from '@web-nx-ng-tsc/web-shared-data-access';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
/**
 * LIBRARY WEB SHARED UI ABOUT US CARD
 *
 *Defines the input properties of the component.
 *
 * Properties
 * 1) The variable data represents the Data object associated with AboutUs
 *
 * dataAboutUs = {
 *  img: 'ImgUrl of AboutUs',
 *  title: 'Title of AboutUs'
 *  description: 'Description of AboutUs'
 * }
 *
 * Example: [data]="dataAboutUs"
 */

@Component({
  selector: 'lib-web-shared-ui-about-us-card',
  imports: [],
  templateUrl: './lib-about-us-card.component.html',
  standalone: true,
  styleUrl: './lib-about-us-card.component.scss',
})
export class LibAboutUsCardComponent {
  @Input() set data(value: IImageEntity) {
    this.loggingService.log('data => ', value);
    this.dataSignal.set(value);
  }

  private readonly sanitizer = inject(DomSanitizer);
  private readonly loggingService = inject(LoggingService);

  dataSignal = signal<IImageEntity>({
    img: '',
    title: '',
    description: '',
  });

  sanitizedContent(content: any) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}
